<template>
  <el-table-column
    prop="category.name"
    sortable="custom"
    label="Kategória"
    show-overflow-tooltip
    min-width="110px"
  >
    <template slot-scope="scope">
      <span v-if="scope.row.category_id">{{ scope.row.category.name }}</span>
      <span v-else>-</span>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'category.name',
  };
</script>
